module.exports = __webpack_public_path__ + "img/a.c52dc7bf.png";